import React, { useEffect } from 'react';
import './App.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Video from './components/Video';
import ImageCarousel from './components/ImageCarousel';
import Testimonials from './components/Testimonials';
import Gallery from './components/Gallery';
import AffiliateSection from './components/AffiliateSection';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Features />
        <Video />
        <ImageCarousel />
        <Testimonials />
        <Gallery />
        <AffiliateSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;